import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { BaseModel } from "../Generics/BaseModel"

export class CouponEntity extends BaseModel {
  id: number

  userId: string

  code: string

  discountPercentage: number

  status: EEnableStatusType

  hasPerCustomerUsageLimit: boolean

  maxUsagePerCustomer?: number

  hasGlobalUsageLimit: boolean

  maxUsageTotal?: number

  createdAt: string

  constructor(data: Partial<CouponEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.userId = data.userId ?? ""

    this.code = data.code ?? ""

    this.discountPercentage = data.discountPercentage ?? 0

    this.status = data.status ?? EEnableStatusType.Active

    this.hasPerCustomerUsageLimit = data.hasPerCustomerUsageLimit ?? false

    this.maxUsagePerCustomer = data.maxUsagePerCustomer ?? undefined

    this.hasGlobalUsageLimit = data.hasGlobalUsageLimit ?? false

    this.maxUsageTotal = data.maxUsageTotal ?? undefined

    this.createdAt = data.createdAt ?? ""
  }

  getDiscountValue(total: number): number {
    if (this.status !== EEnableStatusType.Active) {
      return 0
    }

    if (this.discountPercentage <= 0) {
      return 0
    }

    return (total * this.discountPercentage) / 100
  }
}
